<template>
    <div class="introductionBox">
       <businessBanner tabIndex="2"></businessBanner>
       <div :class="isMobile?'mobileShow':'mainShow'">
        <p class="font20 fontw">造价咨询</p>
        <p class="mt36 jies">集团造价咨询业务开展于2003年，并于2005年在业内取得工程造价咨询甲级资质。 </p>
       </div>
       <div :class="isMobile?'mobileShows':'mainShows'">
            <div :class="isMobile?'mainM':'main clearfix'">
                <div :class="isMobile?'contM':'fl contLeft'"> 
                    <div :class="isMobile?'contTM':'contT'">造价产品</div>
                    <p>集团造价咨询项目年立项600余项，服务过程涵盖了项目决策阶段、招投标阶段、施工阶段、竣工阶段等项目全生命周期，造价产品包括估算编制、审核，概算编制、审核，清单编制、审核，限价/预算编制、审核，施工阶段全过程造价咨询，结算编制、审核以及造价鉴定等7项。</p>
                </div>
                <img :class="isMobile?'contImgShow':'fr zaojIng'" src="@/assets/businessScope/zaoj.png" alt="">
            </div>
       </div>
        <div :class="isMobile?'mainM':'main clearfix'">
            <p v-if="isMobile" :class="isMobile?'contTM':''">业务荣誉</p>
            <img :class="isMobile?'contImgShow':'fl xmImg'" src="@/assets/businessScope/yej.png" alt="">
            <div :class="isMobile?'contM':'fr contd'">
                <div v-if="!isMobile" :class="isMobile?'contTM':'contT'">业务荣誉</div>
                <p>凭借优良的资信水平、突出的业务能力以及丰富的业绩案例，集团获得了多家国家及省级行业权威机构认可：中国建设工程造价管理协会认证AAA级信用企业、中国建设工程造价管理协会会员单位、河北省建设工程造价管理协会副会长单位，并多次获得国家及省市级优秀造价成果奖项：中国建设工程造价管理协会优秀造价成果奖、河北省优秀造价成果一、二、三等奖等。</p>
            </div>
        </div>
        <!-- 典型业绩展示 -->
        <TypicalAchievement category-id="100137" :show-tabs="false" :show-pagination="false" :max-count="6" />
    </div>
</template>

<script>
import businessBanner from '@/components/businessBanner'
import TypicalAchievement from '@/components/TypicalAchievement.vue'
	export default {
		name:'EarlierConsultation',
        components:{businessBanner, TypicalAchievement},
        data() {
            return {

            }
        },
        mounted() {

        }
	}
</script>

<style scoped>
    .introductionBox{
        padding-bottom: 50px;
    }
    .mainShows{
        width: 100%;
        background-color: #F7F9FD;
        margin-top: 42px;
    }
    .mobileShows{
        width: 100%;
        background-color: #F7F9FD;
        margin-top: 20px;
    }
    .main{
        width: 1200px;
        margin: 0 auto;
        padding-top:47px;
        padding-bottom: 100px;
    }
    .mainM{
        width: 100%;
        margin: 0 auto;
        padding: 10px;
    }
    .jies{
        line-height: 30px;
        text-indent: 2em;
    }
    .cont{
        width: 525px;
        color: #666;
    }
    .contM{
        width: 100%;
        color: #666;
        line-height: 30px;
    }
    .contM p{
        text-indent: 2em;
    }
    .contT{
        color: #247CD6;
        font-size: 28px;
        margin-top: 60px;
        margin-bottom: 31px;
    }
    .contTM{
        color: #247CD6;
        font-size: 28px;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .contT+p{
        line-height: 36px;
        text-indent: 2em;
    }
    .erhP{
        line-height: 36px;
        margin-top: 10px;
        text-indent: 2em;
    }
    .contImgShow{
        max-width: 100%;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .xmImg{
        width: 656px;
        margin-top: 33px;
    }
    .contd{
        width: 525px;
        color: #666;
    }
    .contLeft{
        width:525px;
        color: #666;
    }
    .zaojIng{
        width: 607px;
        display: block;
       margin-top: 42px;
    }
</style>